export default __webpack_public_path__ + "static/media/feature_3@3x.4adcc87e.png";